import { Controller } from "@hotwired/stimulus"

// Simple ARIA-correct tabs. Markup contract:
//   <div data-controller="gs-tabs" data-gs-tabs-default-value="overview">
//     <div role="tablist">
//       <button data-gs-tabs-target="tab" data-tab="overview" data-action="click->gs-tabs#select">…</button>
//       <button data-gs-tabs-target="tab" data-tab="evidence" data-action="click->gs-tabs#select">…</button>
//     </div>
//     <section data-gs-tabs-target="panel" data-tab="overview">…</section>
//     <section data-gs-tabs-target="panel" data-tab="evidence">…</section>
//   </div>
//
// Persists the selected tab in the URL hash so a refresh keeps the
// user on the same panel.
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values  = { default: String }

  connect() {
    const fromHash = (window.location.hash || "").replace(/^#tab=/, "")
    const initial  = fromHash || this.defaultValue || this.tabTargets[0]?.dataset.tab
    this.show(initial)
  }

  select(event) {
    event.preventDefault()
    const name = event.currentTarget.dataset.tab
    if (!name) return
    this.show(name)
    history.replaceState(null, "", `#tab=${name}`)
  }

  show(name) {
    this.tabTargets.forEach((btn) => {
      const active = btn.dataset.tab === name
      btn.classList.toggle("gs-tab--active", active)
      btn.setAttribute("aria-selected", active ? "true" : "false")
      btn.setAttribute("tabindex", active ? "0" : "-1")
    })
    this.panelTargets.forEach((panel) => {
      const active = panel.dataset.tab === name
      panel.hidden = !active
    })
  }
}
